// Function to redirect to a specified URL after a delay
export const routeToUrl = (url) => {
  setTimeout(() => {
    window.location.replace(url);
  }, 2000);
};
